import { render, staticRenderFns } from "./editarPromocion.vue?vue&type=template&id=18347630&scoped=true&"
import script from "./editarPromocion.vue?vue&type=script&lang=js&"
export * from "./editarPromocion.vue?vue&type=script&lang=js&"
import style0 from "./editarPromocion.vue?vue&type=style&index=0&id=18347630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18347630",
  null
  
)

export default component.exports